import React from 'react';

type OwnProps = {
  className?: string;
};

const PersonalDetails = ({ className }: OwnProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="14"
    viewBox="0 0 12 14"
    className={className}
  >
    <g>
      <path d="M12 11.638c0-2.342-1.77-4.285-4.085-4.543A3.707 3.707 0 0 0 6 .21a3.707 3.707 0 0 0-1.913 6.885C1.772 7.353 0 9.295 0 11.638v.13l.003.002A9.39 9.39 0 0 0 6 13.923a9.386 9.386 0 0 0 5.998-2.154H12z" />
    </g>
  </svg>
);

export default PersonalDetails;
